import { Capacitor } from '@capacitor/core';
export default defineNuxtPlugin((nuxtApp) => {
    if (Capacitor.getPlatform() === 'ios') {
      document.body.classList.add('ios-safe-area');
    }
})
